/** Brand color for location / address pin (KEEP IN SYNC with mobile LocationPinIcon.js) */
export const LOCATION_PIN_COLOR = "#7F3354";

/** Standard map pin for address rows (replaces legacy map.svg with white circle background). */
export function LocationPinIcon({ size = 24, color = LOCATION_PIN_COLOR }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
    </svg>
  );
}
